<div
  *ngIf="showAlertAdvisoriesHeader"
  [style.visibility]="'hidden'"
  class="alert-advisory-main-container fixed-top advisory-on-load"
>
  <div class="container">
    <div class="row">
      <div aria-labelledby="modal-title" class="col-11 p-0">
        <div class="advisory-icon icon-Advisories-Icon"></div>
        <div class="alert-advisory-details">
          <div
            *ngIf="
              !setDefaultDisplay && contentAlertAdvisories?.alertAdvisoriesLabel
            "
            class="advisory-text-label advisory-display-block"
            id="modal-title"
          >
            {{
              contentAlertAdvisories
                ? contentAlertAdvisories.alertAdvisoriesLabel
                : 'Alerts & Advisories'
            }}
          </div>
          <a
            *ngIf="
              setDefaultDisplay && contentAlertAdvisories?.alertAdvisoriesLabel
            "
            [attr.href]="
              viewAllLabel
                ? contentAlertAdvisories.viewAllAdvisoriesLink
                : '/content/www/en_US/traveling-with-us/advisories.html'
            "
            [attr.target]="
              contentAlertAdvisories?.advisoriesNewWindow === 'true'
                ? '_blank'
                : ''
            "
            class="advisory-text-label advisory-display-block"
            id="modal-title"
          >
            {{
              contentAlertAdvisories
                ? contentAlertAdvisories.alertAdvisoriesLabel
                : 'Alerts & Advisories'
            }}
            <span class="advisory_arrow_span">
              <img
                alt="arrow"
                class="advisory_arrow"
                src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
              />
              <span class="sr-only">Opens in a new window</span>
              <!--jira- 1000, AX issue -->
            </span>
          </a>
          <div
            *ngIf="advisories?.title"
            [innerHTML]="advisories.title"
            class="advisory-desc advisory-display-block advisory-desc-content"
          ></div>
          <div
            *ngIf="!setDefaultDisplay && viewAllLabel"
            class="view-all-advisories advisory-display-block"
          >
            <a
              [attr.href]="
                viewAllLabel
                  ? contentAlertAdvisories.viewAllAdvisoriesLink
                  : '/content/www/en_US/traveling-with-us/advisories.html'
              "
              [attr.target]="
                contentAlertAdvisories?.advisoriesNewWindow === 'true'
                  ? '_blank'
                  : ''
              "
              class="view-all-link"
            >
              {{ viewAllLabel ? viewAllLabel : 'View All' }}
              <span
                *ngIf="contentAlertAdvisories?.advisoriesNewWindow === 'true'"
                class="sr-only"
              >
                Open in new window
              </span>
            </a>
          </div>
        </div>
      </div>
      <div class="close-advisory col-1 pr-0 pl-0">
        <button
          (click)="close()"
          class="advisory-close-icon float-right circle-outline icon-moreoptionsclose"
          role="button"
        >
          <span class="sr-only">Close</span>
        </button>
      </div>
    </div>
  </div>
</div>
